import { useEffect, useState } from "react";
import { FiImage } from "react-icons/fi";
import { getMediaPreviewColors } from "../../../shared/components/media/MediaSelectionPreview";

interface StoreTypeImagePreviewProps {
  imageUrl?: string | null;
  name: string;
  className?: string;
}

const StoreTypeImagePreview = ({
  imageUrl,
  name,
  className = "",
}: StoreTypeImagePreviewProps) => {
  const [hasImageError, setHasImageError] = useState(false);
  const fallbackColors = getMediaPreviewColors(name || "");

  useEffect(() => {
    setHasImageError(false);
  }, [imageUrl]);

  const shouldShowImage = !!imageUrl && !hasImageError;

  if (shouldShowImage) {
    return (
      <div className={`store-type-image-preview image ${className}`.trim()}>
        <img
          src={imageUrl || ""}
          alt={name || "Store type"}
          onError={() => setHasImageError(true)}
        />
      </div>
    );
  }

  return (
    <div
      className={`store-type-image-preview fallback ${className}`.trim()}
      style={{
        backgroundColor: fallbackColors.background,
        color: fallbackColors.color,
      }}
      aria-hidden="true"
    >
      <FiImage size={28} strokeWidth={2.6} />
    </div>
  );
};

export default StoreTypeImagePreview;
